<template>
    <div>

        <div class="cc-banner"
        data-content-text='Използваме "бисквитки" и други технологии за подобряване и персонализиране на потребителското ви изживяване, анализи за оптимизация и реклами в партньорство с трети страни. Използваме наши собствени бисквитки и бисквитки от трети страни. С натискането на бутона OK приемате използването на всички бисквитки. Винаги задаваме необходимите бисквитки. Изберете {preferencesUrl} Управление на предпочитанията{/preferencesUrl}, за да коригирате предпочитанията си и да намерите повече информация.'
        data-url="https://www.takeaway.com/bg/cookiestatement"
        data-url-text="Управление на предпочитанията."
        data-hide-link-after-text="true"
        data-button-text="OK"
        data-button-text-aria="OK Button"
        data-button-essential-package="Основен пакет за бисквитки"
        data-button-essential-package-aria="Essential package aria">
        </div>

    </div>
</template>

<script>

export default {
    mounted() {
        window.addEventListener('load', () => this.addCookies());
    },
    data: function() {
        return {
        }
    },
    methods: {
        addCookies() {
            let cookie;
            let name = "cookieConsent=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');

            for(let i = 0; i <ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    cookie = c.substring(name.length, c.length);
                }
            }

            if (cookie == undefined) {

                let cookiesScript = document.createElement('script')
                cookiesScript.setAttribute('src', 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/cookie-styles-09-2022/cookie-wall-with-polyfill.59c6866ee421a693445a.js');
                document.head.appendChild(cookiesScript);

            }
        }
    }
}
</script>